const zh = {
  "page.home.title": "首页",
  "page.home.subtitle": "从零到猛男的完整蜕变指南",
  "nav.home": "首页",
  "nav.training": "训练计划",
  "nav.diet": "饮食方案",
  "nav.body": "体型塑造",
  "nav.mental": "意志力突破",
  "nav.about": "关于我们",
};

export default zh;